<template>
<main-content>
    <kt-panel-body v-if="ip_location !== 'IR'">
        <div class="alert alert-danger" role="alert">
            {{ $t('label.ir_ip_error') }}
        </div>
    </kt-panel-body>
    <gateway-form v-if="ip_location === 'IR' && !gateway_create" :form_data="form_data" :submit="submit" :wizard="wizard"></gateway-form>
    <contract-modal ref="contract_modal" @signed="onContractSigned" @enamad-error="onEnamadError" @closed="onContractClosed"></contract-modal>
    <div v-if="gateway_create" class="bg-white shadow-sm p-5 my-3" style="border-radius: 10px">
        <div class="row">
            <div class="col-md-12">
                <div class="h4">{{ $t('enamad_services.enamad_register') }}</div>
            </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="alert alert-success mb-5 mt-2">
              {{ $t('enamad_services.payment_alert') }}
            </div>
            <div class="d-flex align-items-center justify-content-between">
              <div class="d-flex align-items-center">
                <div>{{ $t('enamad_services.payment_amount') }}</div>
                <div class="mx-2">
                  {{ Number(enamad_data.enamad_pay_amount).toLocaleString() + ' ریال' }}
                </div>
              </div>
              <div>
                <button class="btn btn-success" @click="enamadPayment">{{ $t('enamad_services.enamad_pardakht') }}</button>
              </div>
            </div>
          </div>
        </div>
        <div class="row" v-if="show_error">
          <div class="col-md-12 my-5">
            <div class="alert alert-danger">{{ error }}</div>
          </div>
        </div>
      </div>
</main-content>
</template>

<script>
import mainContent from '@/components/main-content'
import GatewayForm from './components/form'
import ContractModal from './components/contract-modal'
import $ from 'jquery'
import { gatewayService, authService } from '@/common/api.service'
import { mapGetters } from 'vuex'
import { userTypes } from '@/constants/userTypes'
import {BASE_PATH} from "@/common/config";
import {shopType} from "@/constants/ShopType";

export default {
    components: {
        'main-content': mainContent,
        'gateway-form': GatewayForm,
        'contract-modal': ContractModal
    },
    data() {
        return {
            ip_location: '',
            user_types: userTypes,
            wizard: {
                current_step: 2,
                show: true,
                navigable: true,
                submit_in_progress: false,
                api_errors: {},
            },
            enamad_data: {},
            gateway_create: false,
            error: '',
            show_error: false,
        }
    },
    computed: {
        form_data: {
            get: function() {
                return this.$store.state.gateway.form_data
            },
            set: function(value) {
                this.$store.commit('gateway/setFormData', value)
            }
        },
        ...mapGetters('user', [
            'current_user',
        ]),
    },
    beforeRouteEnter (to, from, next) {
        next(vm => {
            vm.$store.commit('gateway/clearFormData');
        })
    },
    mounted() {
        authService.get_ip().then(response => {
            this.ip_location = response.data.countryCode;
        });

        if (this.$store.getters["pardakhtShakhsi/status"] != 'success') {
            this.$store.dispatch("pardakhtShakhsi/fetch");
        }
    },
    methods: {
        submit(e) {
            this.wizard.submit_in_progress = true;
            let form = $('#gateway_form')
            let btn = $('#submit_btn')
            form.validate({
                rules: {
                    farsi_name: {
                        required: true,
                    },
                    english_name: {
                        required: true,
                    },
                    subcategory_code: {
                        required: true,
                    },
                    address: {
                        required: true,
                    },
                    telephone: {
                        required: true,
                    },
                    phone_number:{
                        required: true,
                        maxlength : 11,
                        minlength : 11,
                        number: true
                    },
                    logo: {
                        required: true,
                    },
                    sheba_number: {
                        required: true,
                    },
                    wage: {
                        required: true,
                    },
                    site_address: {
                        required: true,
                    },
                    tax_payer_code: {
                        required: true,
                        maxlength : 10,
                        minlength : 10,
                    },
                    birth_crtfct_number: {
                        required: () => {
                            return this.current_user.user_type == this.user_types.REAL;
                        },
                        // maxlength : 1,
                        minlength : 1,
                    },
                    settlement_type: {
                        required: true
                    },
                    ip_title0: {
                      required: true
                    }
                }
            })

            if(!form.valid()) {
                this.wizard.submit_in_progress = false;
                return;
            }

            let params = this.$store.getters['gateway/form_data'];

            if (this.form_data.type == shopType.PARDAKHT_SHAKHSI || this.form_data.type == shopType.SERVICES){
                this.form_data.has_enamad = 1;
                this.form_data.tax_payer_code = '1111111111';
            }

            params.namad_services_code = [params.namad_services_code];
            params.merchant_share_percent = 100;

            gatewayService.create(params).then(response => {
                const data = response.data.data
                // The request is a draft until its contract is signed in the modal.
                if (data.contract_required) {
                    this.$refs.contract_modal.open(data.shop_id)
                    return
                }
                this.afterGatewaySubmitted(data, params.has_enamad === 0)
            })
            .catch(({response}) => {
                if (
                    response.data.tag == 'enamad_user_error' ||
                    response.data.tag == 'enamad_domain_error' ||
                    response.data.tag == 'enamad_error'
                ){
                  return this.$router.push(`/gateways/update/${response.data.data.shop_id}/register-enamad`)
                }

                if(response.data) {
                    try { form.validate().showErrors(response.data.data) } catch(e) {}
                    this.$set(this.wizard, 'api_errors', response.data.data || {})
                }
                // this.showMsg(form, 'danger', response.data.message)
            })
            .finally(() => {
                this.wizard.submit_in_progress = false;
            })
        },
        onContractSigned(data) {
            this.afterGatewaySubmitted(data, data.has_enamad === false)
        },
        onEnamadError(body) {
            this.$router.push(`/gateways/update/${body.data.shop_id}/register-enamad`)
        },
        onContractClosed() {
            this.toastr.info('درخواست درگاه به‌صورت پیش‌نویس ذخیره شد. برای ثبت نهایی، از لیست درگاه‌ها قرارداد را امضا کنید.')
            this.$store.dispatch('gateway/gatewayTab', 1)
            this.$router.push('/gateways')
        },
        afterGatewaySubmitted(data, needs_enamad_payment) {
            // redirect to enamad payment
            if (needs_enamad_payment) {
                this.enamad_data = data
                this.gateway_create = true
                return
            }
            // redirect to gateways
            this.$store.dispatch('gateway/gatewayTab', 1)
            this.$router.push('/gateways')
        },
        enamadPayment(){
            let userId = JSON.parse(localStorage.getItem('user'))
            const form = document.createElement("form")
            const input_shop_id = document.createElement("input")
            const input_user_id = document.createElement("input")
            form.action = BASE_PATH + '/gateway/enamad/pay'
            form.method = "GET"
            input_shop_id.type ="hidden"
            input_shop_id.name = "user_shop_id"
            input_shop_id.value = this.enamad_data.shop_id
            input_user_id.type ="hidden"
            input_user_id.name = "user_id"
            input_user_id.value = userId.id
            form.appendChild(input_user_id)
            form.appendChild(input_shop_id)
            document.body.appendChild(form)
            form.submit()
        },
        redirectToGateways(){
            this.$router.push('/gateways')
        }
    },
}
</script>
